module.exports = __webpack_public_path__ + "img/pic_price_sell@2x.d92078c9.png";